<qwiko-new-payment></qwiko-new-payment> <qwiko-wifi-qrcode></qwiko-wifi-qrcode>
<qwiko-payment-qrcode></qwiko-payment-qrcode>
